import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getActivityLogsAPI } from "api/userActivityLogs";

export const getActivityLogs = createAsyncThunk(
  "activityLogs/fetch",
  async (
    { page, limit, searchTerm, targetType, filterModel, sortModel },
    { rejectWithValue },
  ) => {
    try {
      const data = await getActivityLogsAPI({
        page,
        limit,
        searchTerm,
        targetType,
        filterModel,
        sortModel,
      });
      return data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data || { message: "Failed to fetch logs" }
      );
    }
  }
);

const activityLogsSlice = createSlice({
  name: "activityLogs",
  initialState: {
    data: [],
    loading: false,
    error: null,
    meta: {
      page: 1,
      limit: 20,
      totalPages: 0,
      totalRecords: 0,
    },
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getActivityLogs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getActivityLogs.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
        state.meta = action.payload.meta;
      })
      .addCase(getActivityLogs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Error";
      });
  },
});

export default activityLogsSlice.reducer;
